module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_help_remoteEntry_mjs_d16284ce__;